import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/hotNews";
import { hotRankBadge } from "@/utils/content";

export default function RankingRow({ item, rank }: { item: NewsItem; rank: number }) {
  const badgeClass = rank <= 3 ? hotRankBadge[rank - 1] : "bg-background-200 text-foreground-600";
  return (
    <Link
      to={`/news/detail/${item.slug}`}
      className="group flex items-center gap-3 rounded-xl px-2 py-3 transition-colors hover:bg-background-100"
    >
      <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-lg font-heading text-sm ${badgeClass}`}>
        {rank}
      </span>
      <div className="min-w-0 flex-1">
        <h3 className="truncate text-sm font-semibold group-hover:text-primary-700 transition-colors">{item.title}</h3>
        <span className="text-xs text-foreground-500">{item.tag} · {item.date} {item.time}</span>
      </div>
      <div className="shrink-0 text-right">
        <div className="flex items-center justify-end gap-1 text-sm font-bold text-primary-600">
          <i className="ri-fire-line"></i>
          {item.heat}
        </div>
        <span className="text-xs text-foreground-400">热度</span>
      </div>
    </Link>
  );
}